import { render, staticRenderFns } from "./withdrawalList.vue?vue&type=template&id=750f33d4&scoped=true"
import script from "./withdrawalList.vue?vue&type=script&lang=js"
export * from "./withdrawalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750f33d4",
  null
  
)

export default component.exports